import React from 'react';

function Home() {
  return (
    <div>
      <h1>Welcome to ThirdWave Microcare Foundation</h1>
      <p>Your trusted partner in healthcare innovation.</p>
    </div>
  );
}

export default Home;
